import { findIndex } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  open: false,
  full: false,
  count: [],
  description: "",
};

export function TrashReducer(state = { trash: [] }, action) {
  let currentTrash;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_TRASH" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("trash")){
          currentTrash = state.protocolSection.scene.apparatus.trash[findIndex(state.protocolSection.scene.apparatus.trash, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_TRASH':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("trash")){
            protocolSection.scene.apparatus.trash = [ ...protocolSection.scene.apparatus.trash, newObj ]
          } else {
            protocolSection.scene.apparatus.trash = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case 'TRASH_OPEN':

            // xAPI statement
            // sendxAPI({
            //   // Type of statement
            //   verb: {
            //     description: (action.payload.open)?"opened":"closed",
            //     address: (action.payload.open)?"https://w3id.org/xapi/dod-isd/verbs/opened":"https://w3id.org/xapi/dod-isd/verbs/closed"
            //   },
            //   // Where the action occured
            //   context: currentTrash.type + " Trash",
            //   // Result of the action
            //   result: {
            //     success: true,
            //     response: action.payload.open
            //   }
            // })

            currentTrash.open = action.payload.open
            protocolSection.scene.apparatus.trash[findIndex(state.trash, { id: action.payload.id })] = currentTrash

            return { ...state, ...{
              protocolSection: protocolSection
            } }

          case "UNDO":
              //Payload = {lastState}

              if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('trash')) {

                protocolSection.scene.apparatus.trash = action.payload.lastState.scene.apparatus.trash

                return { ...state, ...{
                  protocolSection: protocolSection
                } }

              } else {
                return state;
              }

        default:
            return state;
    }
}
